import { render, staticRenderFns } from "./PositionCharts.vue?vue&type=template&id=5138d7c4&scoped=true&"
import script from "./PositionCharts.vue?vue&type=script&lang=js&"
export * from "./PositionCharts.vue?vue&type=script&lang=js&"
import style0 from "./PositionCharts.vue?vue&type=style&index=0&id=5138d7c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138d7c4",
  null
  
)

export default component.exports